import React from 'react'
import "./help.css"
function Help() {
  return (
    <div className='help-container'>
        <div className='help-body'>
        <div className='help-heading'>
             <h2>
             Looking For help?
             </h2>
             <p>
             Everything you need to get started
             </p>
        </div>
        <div className='help-main'>
            <p>Tutorials</p>
            <p>Frequently asked questions</p>
            <p>Hardware Troubleshooting</p>
            <p>Get Help from Crey</p>
        </div>
        </div>
        
    </div>
  )
}

export default Help